import adminReducer from "@/components/profile/admin/ducks/reducer"
import userReducer from "@/components/profile/ducks/reducer"
import { combineReducers } from "@reduxjs/toolkit"

const profileReducer = combineReducers({
  user: userReducer,
  admin: adminReducer,
})

export default profileReducer
